export const truckTypePrimaryGroup = [
  {
    id: 1,
    name: "32FT MXL",
    param: "32_feet_mxl_container",
    truck_type: [
      {
        id: 36,
        name: "32 Feet Triple Axle",
        truck_type_group_id: 2
      },
      {
        id: 25,
        name: "32 Feet Multi Axle",
        truck_type_group_id: 2
      },
      {
        id: 26,
        name: "32 Feet Multi Axle High Cube",
        truck_type_group_id: 2
      }
    ]
  },
  {
    id: 2,
    name: "32FT SXL",
    param: "32_feet_sxl_container",
    truck_type: [
      {
        id: 24,
        name: "32 Feet Single Axle High Cube",
        truck_type_group_id: 2
      },
      {
        id: 27,
        name: "32 Feet Single Axle",
        truck_type_group_id: 2
      }
    ]
  },
  {
    id: 3,
    name: "20-24 FT",
    param: "20-24_feet_container",
    truck_type: [
      {
        id: 20,
        name: "22 Feet",
        truck_type_group_id: 2
      },
      {
        id: 21,
        name: "24 Feet",
        truck_type_group_id: 2
      },
      {
        id: 16,
        name: "20 Feet",
        truck_type_group_id: 2
      }
    ]
  },
  {
    id: 4,
    name: "17-24 FT",
    param: "17-24_feet_open",
    truck_type: [
      {
        id: 38,
        name: "22 Feet Open",
        truck_type_group_id: 1
      },
      {
        id: 22,
        name: "24 Feet Open",
        truck_type_group_id: 1
      },
      {
        id: 35,
        name: "20 Feet Open",
        truck_type_group_id: 1
      },
      {
        id: 37,
        name: "17 Feet Open",
        truck_type_group_id: 1
      }
    ]
  },
  {
    id: 5,
    name: "10 Whl",
    param: "10_wheel_open",
    truck_type: [
      {
        id: 7,
        name: "10 Whl",
        truck_type_group_id: 1
      }
    ]
  },
  {
    id: 6,
    name: "12 Whl",
    param: "12_wheel_open",
    truck_type: [
      {
        id: 18,
        name: "12 Whl",
        truck_type_group_id: 1
      }
    ]
  },
  {
    id: 7,
    name: "14 Whl",
    param: "14_wheel_open",
    truck_type: [
      {
        id: 33,
        name: "14 Whl",
        truck_type_group_id: 1
      }
    ]
  }
]